module.exports = __webpack_public_path__ + "static/media/trash.3beb93a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trash.svg
// module id = 1492
// module chunks = 1